export default "__VITE_ASSET__5QOj1De2__"